import { useTranslation } from '@/core/i18n';

/**
 * LoginFooter — bottom strip of the login form panel. Mockup pattern: the
 * brand line on the left, a small uptime/region indicator on the right with
 * a sage pulse dot. Region/latency are static placeholders until the real
 * region probe is wired in a later phase.
 */
export function LoginFooter() {
  const { t } = useTranslation();

  return (
    <div className="mt-10 flex w-full items-center justify-between border-t border-sand-200 pt-5 text-[11px]">
      <span className="font-mono uppercase tracking-wider text-muted-foreground">
        {t('auth.login.footer.brand')}
      </span>
      <span className="flex items-center gap-2 font-mono text-muted-foreground">
        <span
          aria-hidden="true"
          className="inline-flex h-2 w-2 rounded-full bg-sage-500 animate-sun-pulse"
        />
        <span>{t('auth.login.footer.region')}</span>
      </span>
    </div>
  );
}

export default LoginFooter;
